{
  "name": "subangstrom-inventory",
  "packageManager": "pnpm@11.1.1",
  "version": "1.12.3",
  "private": true,
  "scripts": {
    "serve": "vite",
    "preview": "vite preview",
    "build": "pnpm run buildcss && vite build",
    "lint": "eslint --ext .js,.vue src",
    "test:product-exports": "node scripts/test-product-data-exports.js",
    "test:rack-puck-order": "node scripts/test-rack-puck-order.js",
    "test:auth-session": "node scripts/test-auth-session-flow.mjs",
    "test:voice-relay": "node scripts/test-voice-relay-events.js",
    "test:voice-refusal": "node scripts/test-voice-refusal.js",
    "test:voice-timers": "node scripts/test-voice-timers.js",
    "test:voice-dock-prefs": "node scripts/test-voice-dock-prefs.js",
    "test:voice-focus": "node scripts/test-voice-focus.js",
    "test:voice-context": "node scripts/test-voice-context.js",
    "test:voice-transcript": "node scripts/test-voice-transcript.js",
    "test:voice-candidates": "node scripts/test-voice-candidates.js",
    "test:voice-hold-gate": "node scripts/test-voice-hold-gate.js",
    "test:voice-dock-layout": "node scripts/test-voice-dock-layout.js",
    "test:voice-dock-wiring": "node scripts/test-voice-dock-wiring.js",
    "test:voice-speak-chunks": "node scripts/test-voice-speak-chunks.js",
    "test:voice-admin": "node scripts/test-voice-admin.js",
    "test:voice-stream-life": "node scripts/test-voice-stream-life.js",
    "test:voice-timing": "node scripts/test-voice-timing.js",
    "test:nav-drawer": "node scripts/test-nav-drawer.js",
    "buildcss": "tailwindcss -i ./styles.css -o ./public/assets/styles.css",
    "tailwind": "pnpm exec tailwindcss -i ./styles.css -o ./public/assets/styles.css --watch",
    "buildprod": "pnpm run buildcss && vite build --mode production"
  },
  "dependencies": {
    "chart.js": "4.4.1",
    "core-js": "3.36.0",
    "mongodb": "3.7.4",
    "smooth-scroll-into-view-if-needed": "1.1.33",
    "socket.io-client": "4.8.3",
    "v-calendar": "3.1.2",
    "vue": "3.4.19",
    "vue-chartjs": "5.3.0",
    "vue-router": "4.2.5",
    "vuex": "4.1.0"
  },
  "devDependencies": {
    "@babel/core": "7.23.9",
    "@babel/eslint-parser": "7.23.10",
    "@vitejs/plugin-basic-ssl": "2.3.0",
    "@vitejs/plugin-vue": "6.0.9",
    "cross-env": "7.0.3",
    "eslint": "7.32.0",
    "eslint-plugin-vue": "8.7.1",
    "tailwindcss": "3.4.1",
    "vite": "8.3.0"
  },
  "eslintConfig": {
    "root": true,
    "env": {
      "node": true
    },
    "extends": [
      "plugin:vue/vue3-essential",
      "eslint:recommended"
    ],
    "parserOptions": {
      "parser": "@babel/eslint-parser",
      "requireConfigFile": false,
      "sourceType": "module"
    },
    "rules": {}
  },
  "browserslist": [
    "> 1%",
    "last 2 versions",
    "not dead",
    "not ie 11"
  ]
}
